export default "<canvas id=\"items-prices-usd-chart\"></canvas>\r\n"